import { render, staticRenderFns } from "./ProcurementRequisition.vue?vue&type=template&id=49c7f350"
import script from "./ProcurementRequisition.vue?vue&type=script&lang=js"
export * from "./ProcurementRequisition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports